<template>
  <div id="osList">
    <filtros-externa-armazem @update-filters="updateFilters">
      <template slot="pagination"><os-pagination></os-pagination></template>
    </filtros-externa-armazem>
    <div class="col-12 text-center pt-3 animated fadeout" v-if="items == 'loading'">
      <span style="font-size: 2rem">
        <i class="fas fa-pulse fa-spinner mr-3"></i>{{this.$t('Carregando')}}...
      </span>
    </div>
    <div class="row" v-if="items && items !== 'loading'">
      <div class="col-12 mb-3 text-center">
        <span v-if="items == 'loading'">
          {{this.$t('Carregando')}}...
        </span>
        <span v-if="items !== 'loading' && items.total > 0">
          {{ $t('Exibindo resultado') }}
          <span class="badge badge-light" style="font-size:18px">{{ items.from }} <span
              class="font-weight-normal">a</span>
            {{ items.to }}</span>
          {{ $t('de') }}
          <span class="badge badge-warning" style="font-size:18px">{{
            items.total
            }}</span>
        </span>
        <span class="w-100 text-center" v-if="items !== 'loading' && !items.total">
          {{ $t('Nenhum resultado encontrado') }}.
        </span>
      </div>

      <os-card class="col-xl-3 col-lg-4 col-md-6" v-for="(os, index) in items.data" :key="index" :os="os"></os-card>

      <div class="col-12 d-flex justify-content-center mt-2 mb-5">
        <os-pagination position="bottom"></os-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import OsCard from '@/components/OsCard'
import OsPagination from '@/components/OsPagination'
import FiltrosExternaArmazem from '@/components/FiltrosExternaArmazem'

export default {
  components: {
    OsCard,
    FiltrosExternaArmazem,
    OsPagination
  },

  created(){
    const filial = JSON.parse(localStorage.filial)
    let filters = {
        placa: '',
        tipo: '',
        de: '',
        ate: '',
        codigo: '',
        atendeOs: ''
      }

      try{
        const filtrosAplicados = JSON.parse(localStorage.filtrosArmazemExternas);

        if(filtrosAplicados.checkSaveFilter){
          filters = filtrosAplicados
        }
      } catch (e) {
        console.log(e)
      }

      if(filial.atendeOs == "S") {
        filters.atendeOs = 'S'
      }

      if(filial.fornecExt === 'S') {
        filters.fornecExt = filial.tecnicoId
      }

      this.$store.commit('os/setFilters', { filters: filters })
      this.$emit('update-filters', { filters: filters })
  },

  data () {
    return {
      showFiltros: false,
      recarregarFiltro: true
    }
  },

  computed: {
    items () {
      if (!this.$store.getters['os/page'](this.paginacao.currentPage)) {
        this.fetchItemsFromApi()
      }

      return this.$store.getters['os/page'](this.paginacao.currentPage)

    },
    paginacao () {
      return this.$store.getters['os/pagination']
    }
  },

  mounted () {
    this.$store.dispatch('os/fetchFromApiArmazemExterna', {})
  },

  methods: {
    refreshFilter () {
      this.recarregarFiltro = false
    },

    updateFilters (newFilters) {
      this.$store.dispatch('os/reset')
      this.fetchItemsFromApi()
    },

    fetchItemsFromApi () {
      this.$store.dispatch('os/fetchFromApiArmazemExterna', {})

    }
  }
}
</script>

<style lang="scss">
  .icon--custom {
    top: 50px;
  }
</style>